import { OrgUnitLocation, OrgUnitsDataActions } from '@msdyn365-commerce/retail-proxy';
import { useEffect, useState } from 'react';
import { IHeiStoreAddressData } from './hei-store-address.data';
import { IHeiStoreAddressProps } from './hei-store-address.props.autogenerated';

export type IHeiStoreAddressViewProps = IHeiStoreAddressProps<IHeiStoreAddressData> & {
    store: OrgUnitLocation;
};

const HeiStoreAddress = (props: IHeiStoreAddressProps<IHeiStoreAddressData>) => {
    const {
        config: { orgUnitNumber },
        context
    } = props;

    const [orgUnitLocation, setOrgUnitLocation] = useState<OrgUnitLocation>();
    const [storeInfoLoaded, setStoreInfoLoaded] = useState(false);

    useEffect(() => {
        const ctx = { callerContext: context.actionContext };

        if (storeInfoLoaded) {
            return;
        }

        setStoreInfoLoaded(true);

        void (async () => {
            try {
                const allStores = await OrgUnitsDataActions.searchOrgUnitLocationsAsync(ctx, {
                    OrgUnitNumber: orgUnitNumber
                });

                const store = allStores?.find(s => s.OrgUnitNumber === orgUnitNumber);

                if (store) {
                    setOrgUnitLocation(store);
                }
            } catch (error) {
                context.telemetry.exception(error as Error);
            }
        })();
    }, [orgUnitNumber]);

    if (!orgUnitLocation) {
        return null;
    }

    return props.renderView({
        ...props,
        store: orgUnitLocation
    });
};

export default HeiStoreAddress;
